export const LOGIN = 'login';
export const ADD_EDIT_CARD = 'add_edit_card'
export const PRACTICE_CARDS = 'practice_cards';
